
import { defineComponent, reactive, toRefs } from 'vue'
import jfschool from '@/api/jfschool'
import nineDirections from '@/api/nineDirections'
import router from '@/router/index'
import { useRoute } from 'vue-router'
import store from '@/store'
import { PlayCircleFilled } from '@ant-design/icons-vue'
import Nodata from '@/components/page/nodata.vue'
import Card from './card.vue'
export default defineComponent({
  components: {
    PlayCircleFilled,
    Nodata,
    Card
  },
  setup() {
    type pageDataType = {
      navData: {
        categoryList: Array<{ code: string; name: string }>
        stepList: Array<{ code: string; name: string }>
      }
      selectedCategory: string
      selectedStep: string
      selectedTeacherLabel: string
      teacherLabelList: Array<{ code: string; name: string }>
      list: Array<any>
      loading: boolean
      pageNo: number
      pageSize: number
      total: number
    }
    const route = useRoute()
    const pageData: pageDataType = reactive({
      navData: {
        categoryList: [],
        stepList: []
      },
      selectedCategory: route.query.from === 'star' ? '34635b2899a441a181e840825160041a' : '',
      selectedStep: '',
      selectedTeacherLabel: '',
      teacherLabelList: [
        { code: '1', name: '首席' },
        { code: '2', name: '资深' },
        { code: '3', name: '投顾' }
      ],
      list: [],
      loading: false,
      pageNo: 1,
      pageSize: 12,
      total: 0
    })
    
    // 获取导航数据（类别+阶段）
    function getNavData() {
    
      nineDirections.schoolCourseAllNav().then((res: any) => {
        pageData.navData = res.data || { categoryList: [], stepList: [] }
        getAllCourse()
      })
    }
    
    function getAllCourse() {
      pageData.loading = true
      const params: any = {
        pageNo: pageData.pageNo,
        pageSize: pageData.pageSize,
        sortType: '1'
      }
      console.log('pageData',pageData)
      if (pageData.selectedCategory) {
        params.classificationCode = pageData.selectedCategory
      }
      if (pageData.selectedStep) {
        params.tagCode = pageData.selectedStep
      }
      if (pageData.selectedTeacherLabel) {
        params.teacherLabel = Number(pageData.selectedTeacherLabel)
      }
        nineDirections.schoolCourseAllPage(params, {
          username: route.query.userName as string || '',
          token: route.query.token as string || ''
        }).then((res: any) => {
        pageData.list = res.data?.data || []
        pageData.total = res.data?.total || 0
        pageData.loading = false
      })
    }
    
    getNavData()
    
    function categoryChange(code: string) {
      pageData.selectedCategory = code
      pageData.pageNo = 1
      getAllCourse()
    }
    
    function stepChange(code: string) {
      pageData.selectedStep = code
      pageData.pageNo = 1
      getAllCourse()
    }

    function teacherLabelChange(code: string) {
      pageData.selectedTeacherLabel = code
      pageData.pageNo = 1
      getAllCourse()
    }
    
    function onPageChange(page: number) {
      pageData.pageNo = page
      getAllCourse()
    }
    
    function onPageSizeChange(current: number, size: number) {
      pageData.pageNo = 1
      pageData.pageSize = size
      getAllCourse()
    }
    
    function gotoCourseDetail(p: { courseNo: any; lessonNo: string }) {
      router.push({
        name: 'coursedetail',
        query: {
          ...route.query,
          courseNo: p.courseNo,
          from: 'allcourse'
        }
      })
    }
    return {
      ...toRefs(pageData),
      categoryChange,
      stepChange,
      teacherLabelChange,
      onPageChange,
      onPageSizeChange,
      gotoCourseDetail
    }
  }
})
